import { render, staticRenderFns } from "./outorder.vue?vue&type=template&id=4da89c22&scoped=true&"
import script from "./outorder.vue?vue&type=script&lang=js&"
export * from "./outorder.vue?vue&type=script&lang=js&"
import style0 from "./outorder.vue?vue&type=style&index=0&id=4da89c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da89c22",
  null
  
)

export default component.exports